import { match } from 'ts-pattern';
import { CMSHorizontalCard } from './cms-horizontal-card';
import type { CMSCard as CMSCardType } from '../schemas';
import { CMSVerticalCard } from './cms-vertical-card';
import { CMSResponsiveCard } from './cms-responsive-card';
import React from 'react';

export interface CMSCardProps {
  cardData: CMSCardType;
  className?: string;
  isFromBannerWithImage?: boolean;
  style?: React.CSSProperties;
}

const CMSCard = ({
  cardData,
  className,
  isFromBannerWithImage = false,
}: CMSCardProps) => {
  return match(cardData.layout.key)
    .with('vertical', () => (
      <CMSVerticalCard
        className={className}
        isFromBannerWithImage={isFromBannerWithImage}
        cardData={cardData}
      />
    ))
    .with('horizontal', () => (
      <CMSHorizontalCard className={className} cardData={cardData} />
    ))
    .with('responsive', () => (
      <CMSResponsiveCard className={className} cardData={cardData} />
    ))
    .otherwise(() => null);
};
export { CMSCard };
